"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RoRo API
 * This documents RoRo APIs for handling public facing App needs
 *
 * The version of the OpenAPI document: 0.0.43
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var VehicleVtypeEnum;
(function (VehicleVtypeEnum) {
    VehicleVtypeEnum["Scooter"] = "Scooter";
    VehicleVtypeEnum["Bike"] = "Bike";
})(VehicleVtypeEnum = exports.VehicleVtypeEnum || (exports.VehicleVtypeEnum = {})); /**
* @export
* @enum {string}
*/
var VehicleAvailabilityEnum;
(function (VehicleAvailabilityEnum) {
    VehicleAvailabilityEnum["Available"] = "AVAILABLE";
    VehicleAvailabilityEnum["Inuse"] = "INUSE";
    VehicleAvailabilityEnum["Out"] = "OUT";
})(VehicleAvailabilityEnum = exports.VehicleAvailabilityEnum || (exports.VehicleAvailabilityEnum = {}));
function VehicleFromJSON(json) {
    return VehicleFromJSONTyped(json, false);
}
exports.VehicleFromJSON = VehicleFromJSON;
function VehicleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'vtype': json['vtype'],
        'batteryPercent': !runtime_1.exists(json, 'batteryPercent') ? undefined : json['batteryPercent'],
        'availability': !runtime_1.exists(json, 'availability') ? undefined : json['availability'],
        'location': !runtime_1.exists(json, 'location') ? undefined : _1.LocationFromJSON(json['location']),
        'lock': !runtime_1.exists(json, 'lock') ? undefined : json['lock'],
        'setting': !runtime_1.exists(json, 'setting') ? undefined : _1.ScooterSettingsDtoFromJSON(json['setting']),
    };
}
exports.VehicleFromJSONTyped = VehicleFromJSONTyped;
function VehicleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'vtype': value.vtype,
        'batteryPercent': value.batteryPercent,
        'availability': value.availability,
        'location': _1.LocationToJSON(value.location),
        'lock': value.lock,
        'setting': _1.ScooterSettingsDtoToJSON(value.setting),
    };
}
exports.VehicleToJSON = VehicleToJSON;
